<template>
  <div
    class="d-flex justify-space-between flex-column position-relative"
    :style="{ height: isHeader && !isMobile ? 'calc(100vh - 150px)' : '' }"
  >
    <div class="cart" :class="[isHeader ? 'overflow' : '']">
      <v-icon
        v-if="!isCheckOut"
        icon="mdi-close mb-2"
        @click="closeMobileSideBar"
      />
      <div class="cart-header">
        <div class="d-flex justify-center align-center ga-3">
          <v-icon
            class="cart-icon"
            :color="'black'"
            :icon="'mdi-cart'"
          ></v-icon>
          <div class="title">{{ $t("CartWidget.title") }}</div>
        </div>
        <div
          v-if="!isCheckOut"
          @click="clearCart"
          class="clear-btn"
          :class="[clearCartDisable]"
        >
          <v-icon :size="15" :icon="'mdi-trash-can-outline'"></v-icon>
          <span>{{ $t("CartWidget.cleanCartBtn") }}</span>
        </div>
      </div>
      <MinOrderAlert
        v-if="!isUserGuest && isUserLogin"
        :isCheckOut="isCheckOut"
      />
      <div v-if="shippingProgress && !isUserGuest" class="shipping-progress">
        <div class="shipping-progress-label">
          <v-icon
            :size="18"
            :icon="
              shippingProgress.reachedFree
                ? 'mdi-truck-check'
                : 'mdi-truck-outline'
            "
          ></v-icon>
          <span>{{ shippingProgressLabel }}</span>
        </div>
        <v-progress-linear
          class="shipping-progress-bar"
          :model-value="shippingProgress.percent"
          :color="shippingProgress.reachedFree ? '#36B079' : '#BD9478'"
          height="16"
          rounded
          bg-color="#f7f7f7"
        ></v-progress-linear>
      </div>
      <div class="d-flex flex-column ga-5 items-warpper">
        <TransitionGroup tag="ul" name="fade" class="transition">
          <productItemCart
            class="item"
            @removeProduct="removeProduct"
            @updateProduct="updateProduct"
            :product="line"
            v-for="line in Cart.OrderLines"
            :key="line.ordi"
            :isQuantityBtnDisable="isQuantityBtnDisable"
          />
        </TransitionGroup>
      </div>
      <NotFound
        v-if="!products"
        imageSrc="/images/empty_cart.svg"
        :title="$t('CartWidget.emptyCartTitle')"
      />
      <CartSummary
        :cartData="cartData"
        :isCheckOut="isCheckOut"
        :isHeader="isHeader"
      />
      <InfoCart
        v-if="!isHeader && !isCartModelOpenHeader"
        :cartPackagesNumber="getCartOrderLinesNumber"
        :cartUnitsNumber="getCartOrderLinesUnitsNumber"
        @openCart="openCart"
        :isCartOpen="isCartOpen"
      />
    </div>
    <v-btn
      v-if="isHeader"
      :disabled="getCartOrderLinesNumber === 0"
      @click="goToCheckout"
      class="endOrder"
      height="50"
      color="#BD9478"
    >
      לסיום הזמנה
    </v-btn>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { formatPrice } from "../../utilities";
import productItemCart from "../helpers/productItemCart.vue";
import CartSummary from "../helpers/CartSummary.vue";
import InfoCart from "../helpers/InfoCart.vue";
import NotFound from "../helpers/NotFound.vue";
import MinOrderAlert from "../helpers/Cart/minOrderAlert.vue";
export default {
  props: {
    isCartOpen: {
      type: Boolean,
    },
    isHeader: {
      type: Boolean,
      default: false,
    },
    isCheckOut: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isQuantityBtnDisable: false,
      products: [],
    };
  },
  components: {
    productItemCart,
    CartSummary,
    NotFound,
    InfoCart,
    MinOrderAlert,
  },
  created() {
    this.$store.dispatch("Orders/fetchShippingTiers");
  },
  methods: {
    GotoCartPage() {
      if (this.Cart?.OrderLines?.length > 0) {
        this.closeMobileSideBar();
        this.$router.push("/cart");
      }
    },
    goToCheckout() {
      // Add your checkout navigation logic here
      this.closeMobileSideBar();
      this.$router.push({ name: "checkOut" });
    },
    closeMobileSideBar() {
      this.$store.dispatch("Orders/setCartModel", false);
    },
    openCart() {
      this.$emit("openCart");
      this.$store.dispatch("Orders/setCartModel", true);
    },
    removeProduct(product) {
      var line = {
        Part: { ...product.Part },
        ordname: product.ordname,
        ordi: product.ordi,
        quant: product.qaunt,
      };
      this.$store.dispatch("Orders/removeProductFromCart", line);
    },
    clearCart() {
      this.$store.dispatch("Orders/clearCart");
    },
    async updateProduct(obj) {
      if (!obj?.product || this.isQuantityBtnDisable) return;

      this.isQuantityBtnDisable = true;
      const { product, quantity } = obj;

      const line = {
        Part: { ...product.Part },
        ordname: product.ordname,
        ordi: product.ordi,
        quant: quantity,
      };

      if (quantity > 0) {
        await this.$store.dispatch("Orders/updateCart", line);
      } else {
        await this.$store.dispatch("Orders/removeProductFromCart", line);
      }

      this.isQuantityBtnDisable = false;
    },
  },
  computed: {
    cartData() {
      return {
        units: this.getCartOrderLinesUnitsNumber,
        packages: this.getTotalCartPackges,
        priceBeforeVAT: this.getTotalCartBeforeVAT,
        totalpriceSavings: this.getTotalCartSavings,
        discount: this.getCartDiscount,
      };
    },
    getTotalCartBeforeVAT() {
      return this.getCartTotalPrice;
    },
    clearCartDisable() {
      return this.Cart?.OrderLines?.length > 0 ? "" : "disabled";
    },
    shippingProgressLabel() {
      const progress = this.getShippingProgress;
      if (!progress) return "";
      if (progress.reachedFree) {
        return this.$t("CartWidget.freeShippingReached");
      }
      const remaining = `₪${formatPrice(progress.remaining)}`;
      return `${this.$t("CartWidget.addMore")} ${remaining} ${this.$t(
        "CartWidget.forFreeShipping"
      )}`;
    },
    shippingProgress() {
      return this.getShippingProgress;
    },
    ...mapGetters({
      getVat: "Orders/getTaxPercent",
      getTotalCartPackges: "Orders/getTotalCartPackges",
      getCartOrderLinesUnitsNumber: "Orders/getCartOrderLinesUnitsNumber",
      getCartOrderLinesNumber: "Orders/getCartOrderLinesNumber",
      getCartTotalPrice: "Orders/getCartTotalPrice",
      getCartDiscount: "Orders/getCartDiscount",
      getTotalCartBeforeVAT: "Orders/getTotalCartBeforeVAT",
      getTotalCartSavings: "Orders/getTotalCartSavings",
      Cart: "Orders/getCart",
      isOpenCart: "Orders/getIsCartModelOpen",
      isMobileSideBarOpen: "isOpenMobileSideBar",
      isMobile: "isMobile",
      isCartModelOpenHeader: "Orders/getIsCartModelOpenHeader",
      minOrderSum: "Orders/getMinOrderSum",
      getShippingProgress: "Orders/getShippingProgress",
      isUserGuest: "AuthModule/isUserGuest",
      isUserLogin: "AuthModule/isAuthenticated",
    }),
  },
};
</script>

<style scoped lang="scss">
.shipping-progress {
  direction: rtl;
  margin-bottom: 20px;
  display: flex;
  flex-direction: column;
  gap: 8px;

  .shipping-progress-label {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 14px;
    font-weight: 600;
  }

  .shipping-progress-bar {
    border: 1px solid #d9cabf;
    border-radius: 20px;
    overflow: hidden;
  }
}
.endOrder {
  width: 100%;
  position: absolute;
  left: 0px;
  bottom: 0px;
}
@media only screen and (max-width: 601px) {
  // .cart {
  //   height: unset !important;
  // }
}
/* 1. declare transition */
.fade-move,
.fade-enter-active,
.fade-leave-active {
  transition: all 0.5s ease;
}

/* 2. declare enter from and leave to state */
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
  transform: translateX(30px);
}

.transition {
  position: relative;
  padding: 0;
  direction: rtl !important;
  list-style-type: none;
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-bottom: 20px;
}
.items-warpper {
  direction: ltr;
  overflow-y: auto;
  max-height: 350px;
  overflow-x: hidden;
  .product {
    &:last-child {
      border-bottom: none !important;
    }
  }
}

@media only screen and (max-width: 601px) {
  .items-warpper {
    max-height: 100%;
    padding-bottom: 40px;
    max-height: 50%;
  }
}

@media only screen and (max-height: 667px) {
  .items-warpper {
    max-height: 32%;
  }
}

.disabled {
  opacity: 0.5;
  pointer-events: none;
}
.cart {
  &.overflow {
    overflow: auto;
  }
  // position: relative;
  // overflow: auto;
  // height: calc(100vh - 300px);
}

@media (max-width: 601px) {
  .cart {
    padding: 5px;
    // height: calc(100vh - 210px);
  }
}

@media (min-width: 601px) {
  .empty-cart {
    margin-top: 140px;
  }
}

.product {
  &:first-child {
    padding-top: 0px;
  }
}
.cart-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 40px;
  .cart-icon {
    // background: $cartMainColor;
    height: 40px;
    width: 40px;
    border-radius: 50%;
  }
  .title {
    font-weight: 600;
    font-size: $mediumTextSize;
  }
  .clear-btn {
    cursor: pointer;
    background: #f8f8f8;
    border: 1px solid #ececec;
    border-radius: 20px;
    padding: 2px 10px;
    display: flex;
    gap: 5px;
    align-items: center;
  }
  .clear-btn.disable {
    opacity: 50%;
    pointer-events: none;
  }
}

@media (max-width: 601px) {
  .button-warpper {
    margin: 0 !important;
  }
}
.button-overly {
  position: absolute;
  left: -5px;
  top: -5px;
  width: 100%;
}
.order-summary {
  border-radius: 0px !important;
  background: $cartMainColor;
}
.btn-text {
  color: white;
  font-size: 22px;
  font-weight: 400;
}
</style>
